<template>
    <AppLayout v-bind="appSharedData.getAppSidebarLayoutProps(pageMeta)">
        <div class="space-y-8">
            <div>
                <MeetingPageTabs :selectedTab="MeetingTabKeyEnum.Recurring" />
            </div>

            <div class="space-y-6">
                <RecurringMeetingCard
                    v-for="bookingData in localBookingsData"
                    :key="bookingData.booking.id.value"
                    :bookingData="bookingData"
                    :displayTimezone="authCompanyUser.displayTimezone"
                />
            </div>

            <div v-if="paginatedBookingsData.numberOfRecords === 0">
                <Card>
                    <template #content>
                        <TableEmptyState title="No recurring meetings found." />
                    </template>
                </Card>
            </div>
            <div v-else>
                <Pagination
                    as="a"
                    :searchResults="paginatedBookingsData"
                    :url="
                        urlFactory.makeRecurringMeetingsUrl(
                            recurringMeetingSearchFilters,
                        )
                    "
                />
            </div>
        </div>

        <PageBottomPadding />
    </AppLayout>
</template>

<script setup lang="ts">
    import { UrlFactory } from '@/Shared/Url/UrlFactory'
    import { ref } from 'vue'
    import AppLayout from '@/Shared/Layout/App/Sidebar/AppLayout.vue'
    import Card from '@/Shared/Component/Card.vue'
    import { MeetingTabKeyEnum } from '@/Shared/AutoGenerated/Types'
    import Pagination from '@/Shared/Component/Pagination.vue'
    import TableEmptyState from '@/Shared/Component/Table/TableEmptyState.vue'
    import {
        type PaginatedResultsType,
        type PageMeta,
        type RecurringMeetingSearchFiltersType,
    } from '@/Shared/AutoGenerated/Main'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import PageBottomPadding from '@/Shared/Layout/App/Sidebar/PageBottomPadding.vue'
    import BookingData from '@/App/Booking/Booking/Entity/BookingData'
    import MeetingPageTabs from '@/App/Booking/Meeting/Component/MeetingPageTabs.vue'
    import RecurringMeetingCard from '@/App/Booking/Recurring/Component/RecurringMeetingCard.vue'
    import Booking from '@/App/Booking/Booking/Entity/Booking'

    interface IndexMeetingsProps {
        pageMeta: PageMeta
        appSharedDataData: any
        paginatedBookingsData: PaginatedResultsType
        recurringMeetingSearchFilters: RecurringMeetingSearchFiltersType
    }

    const props = defineProps<IndexMeetingsProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const localBookingsData = ref<BookingData[]>(
        BookingData.hydrateMultiple(props.paginatedBookingsData.records),
    )
    const authCompanyUser = appSharedData.getAuthCompanyUser()
    const urlFactory = new UrlFactory()
</script>
